const en = {
  "hotel.service.operation_center": "Operations Center",
  "hotel.service.environment": "Environment",
  "hotel.service.service_date": "Date",
  "hotel.service.kind": "Service",
  "hotel.service": "Food Service",
  "hotel.service.line": "Food Service",
  "hotel.service.line.service": "Service",
  "hotel.service.line.room": "Room",
  "hotel.service.line.time_service": "Service Date",
  "hotel.service.line.product": "Product",
  "hotel.service.line.quantity": "Quantity",
  "hotel.service.line.description": "Description",
  "hotel.service.line.order": "Order",
  "hotel.service.line.guest": "Guest",
  "hotel.service.line.charge_button": "Charge",
  "hotel.service.line.stock_move": "Stock Move",
  "hotel.service.line.analytic_account": "Analytic Account",
  "hotel.service.line.unit_price_w_tax": "Unit Price (Incl. Tax)",
  "hotel.service.line.storage": "Storage",
  "hotel.service.lines": "Service Lines",
  "hotel.service.number": "Service Number",
  "hotel.service.notes": "Notes",
  "hotel.service.storage": "Storage",
  "hotel.service.count_services": "Service Count",
  "hotel.service.company": "Company",
  "hotel.service.line.unit_price": "Unit Price",
  "hotel.service.line.state": "Status",
  "hotel.service.line.folio": "Folio",
  "hotel.service.state": "Status",
  "menu.service_hotel": "Services",
  breakfast: "Breakfast",
  lunch: "Lunch",
  dinner: "Dinner",
  "hotel.service.line.draft": "Pending",
  "hotel.service.line.loaded": "Loaded",
  "hotel.service.total": "Total",
  "hotel.service.draft": "Draft",
};
export default en;
